import "./Hardware.html";
import "./Hardware.scss";

import type { IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import HardwareComponentController from "./HardwareComponentController";

export class HardwareComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            siteId: "<",
        };
        this.controller = HardwareComponentController;
        this.templateUrl = "/App/Components/Site/Overview/Hardware/Hardware.html";
    }
}

module("mmManagePortal").component("mmSiteHardware", new HardwareComponent());
